// frontend/src/components/ProtectedRoute.js
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children }) => {
    const { isAuthenticated, isLoading } = useAuth(); // Pega o estado de autenticação e carregamento
    const location = useLocation(); // Pega a localização atual para redirecionamento pós-login

    // 1. Se ainda está carregando a verificação inicial do AuthContext...
    if (isLoading) {
        // Mostra um indicador de carregamento simples
        // (Você pode substituir por um componente Spinner mais elaborado depois)
        return (
            <div className="flex items-center justify-center min-h-screen">
                Carregando autenticação...
            </div>
        );
    }

    // 2. Se NÃO está carregando e NÃO está autenticado...
    if (!isAuthenticated) {
        // Redireciona para a página de login
        // Passa a localização atual (location) no state 'from'.
        // A página de login pode usar isso para redirecionar de volta após o login.
        // 'replace' evita que a rota protegida entre no histórico do navegador.
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // 3. Se NÃO está carregando e ESTÁ autenticado...
    // Renderiza o componente filho (a página protegida)
    return children;
};

export default ProtectedRoute;